import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReloadIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		"data-name": "Icon - Reload",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "m1.04 8.026 3 4.5 3.5-4",
			"data-name": "Path 5309"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.079 12.683A10.473 10.473 0 0 1 14.155.758a10.446 10.446 0 0 1 10.878 9.977 10.421 10.421 0 0 1-10.106 10.737 10.539 10.539 0 0 1-7.549-2.782",
			"data-name": "Path 5310"
		})]
	})
});
export { SvgReloadIcon as ReactComponent };
